import React from 'react';

import {MultiRunWorkspaceWithContext} from '../../components/MultiRunWorkspace/MultiRunWorkspaceWithContext';
import {Theme} from '../Benchmark/Theme';
import {EmptyState} from './EmptyState';
import {useProjectParams} from './useProjectParams';

type WorkspaceTabBodyProps = {
  linkedBenchmarkInfo: Theme | null;
  isTableExpanded: boolean;
  onSetTableExpanded: (isExpanded: boolean) => void;
  runCount: number;
};

export const WorkspaceTabBody = ({
  linkedBenchmarkInfo,
  isTableExpanded,
  onSetTableExpanded,
  runCount,
}: WorkspaceTabBodyProps) => {
  const {entityName, projectName} = useProjectParams();
  if (!runCount) {
    return <EmptyState linkedBenchmarkInfo={linkedBenchmarkInfo} />;
  }
  return (
    <MultiRunWorkspaceWithContext
      entityName={entityName}
      isTableExpanded={isTableExpanded}
      onSetTableExpanded={onSetTableExpanded}
      projectName={projectName}
      recommendGrouping="group-and-jobtype"
      title={`Runs (${runCount})`}
      viewType="project-view"
    />
  );
};
